module.exports = __webpack_public_path__ + "static/media/AeroSimple.d41d8cd9.title";